import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import PageWrapper from '../../components/PageWrapper'
import BorderButton from '../../components/BorderButton'
import { Preloader } from '../../components/Chart/index'
import WhiteBox from '../../components/WhiteBox'

import { getAudiencePrefix } from '../../lib/get-audience-prefix'

import './styles.css'
import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css'
import { Bootstrap2Toggle } from 'react-bootstrap-toggle'

import axios from 'axios'

const Selector = ({ variants, selected, onChangeSelection }) => {
    const clazz = page => (selected === page ? 'selected' : '')
    return (
        <div>
            {variants.map(variant => (
                <span key={variant} className={`segment-list segment-list--selector ${clazz(variant)}`} onClick={() => onChangeSelection(variant)}>
                    verticals
                </span>
            ))}
        </div>
    )
}

class AddAudience extends Component {
    state = {
        name: '',
        selected: {},
        stsegments: 'vertical',
        disableButton: true,
        saving: false,
        description: '',
        branded: true,
        audience_prefix: '',
        alternativeId: ''
    }

    onChange = (segment, value) =>
        this.setState(state => ({
            segments: [...state.segments, segment]
        }))

    onCancel = () => this.props.goBack()
    onSave = () => {
        if (this.state.name) {
            this.setState({ disableButton: true, saving: true })
            /*this.props.history.push(
                '/audiences/import?audienceName=' +
                    encodeURIComponent(this.state.name) +
                    '&description=' +
                    encodeURIComponent(this.state.description) +
                    '&branded=' +
                    this.state.branded
            )*/

            const body = {
                audienceId: this.state.audienceId,
                alternativeId: this.state.alternativeId,
                description: this.state.description
            }
            // if new
            let method = 'POST'
            if (this.state.audienceId != null && this.state.audienceId != '') {
                method = 'PATCH'
            } else {
                body['audienceName'] = this.state.name
                body['branded'] = this.state.branded ? 1 : 0
            }
            axios
                .request({ url: '/audience', method: method, data: body })
                .then(response => {
                    console.log('successfully saved a new audience!', response)
                    this.props.history.push('/audiences')
                })
                .catch(err => {
                    this.setState({ saving: false })
                })
        }
    }

    componentDidMount() {
        let audience_prefix = getAudiencePrefix(this.state.branded)
        this.setState({ audience_prefix: audience_prefix + this.state.name })
    }

    onBrandedChanged(event) {
        console.log('on change ', event)
        //const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
        const value = event
        console.log('onBrandedChanged', value)

        this.setState({ branded: value }, () => {
            let audience_prefix = getAudiencePrefix(this.state.branded)
            this.setState({ audience_prefix: audience_prefix + this.state.name })
        })
    }

    render() {
        const { name } = this.state
        const { segments, loading, hasMore } = this.props
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-10">
                            <WhiteBox>
                                <div
                                    style={{
                                        position: 'relative',
                                        paddingRight: 100
                                    }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src="/img/audience/illy-segment-based-audience.svg" alt="" />
                                        </div>
                                        <div className="col-9">
                                            <h3 style={{ marginTop: 26 }}>NEW AUDIENCE</h3>

                                            <p style={{ fontSize: 'smaller' }}>
                                                Create an audience bases on the interests of the users, across all your properties.
                                            </p>

                                            <div className="row">
                                                <div className="col-12">
                                                    <p style={{ marginTop: 30 }}>Audience Name *</p>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={name}
                                                        onChange={({ target }) =>
                                                            this.setState({
                                                                name: target.value,
                                                                audience_prefix: getAudiencePrefix(this.state.branded) + target.value,
                                                                disableButton: target.value == ''
                                                            })
                                                        }
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>The audience name. This field is mandatory.</font>

                                                    <div className="alert alert-warning" style={{'fontSize': '14px'}}>
                                                        Please refer to the section <b>"Data Guidelines"</b> when you choose your audience name because there are some restrictions in how you can name your segments: <a href="https://www.google.com/doubleclick/dataplatform/policies.html">Google Data Platform Policies</a>.
                                                    </div>

                                                </div>

                                                {/*
                                                <div className="col-3">
                                                    <p style={{ marginTop: 30 }}>Branded</p>
                                                    <Bootstrap2Toggle
                                                        onClick={this.onBrandedChanged.bind(this)}
                                                        on={<span>ON</span>}
                                                        off={<span>OFF</span>}
                                                        size="xs"
                                                        offstyle="secondary"
                                                        active={this.state.branded}
                                                    />
                                                    <br />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Brand the final audience name</font>
                                                </div>
                                                */}
                                            </div>

                                            <p style={{ marginTop: 30 }}>Audience Final Name</p>
                                            <input type="text" className="form-control" readOnly={true} value={this.state.audience_prefix} />
                                            <font style={{ fontSize: '13px', color: '#888' }}>
                                                This is the processed audience name. This value must be unique to all the audience names.
                                            </font>

                                            <p style={{ marginTop: 30 }}>Description</p>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={this.state.description}
                                                onChange={({ target }) => this.setState({ description: target.value, disableButton: target.value == '' })}
                                            />
                                            <font style={{ fontSize: '13px', color: '#888' }}>
                                                Optional Description. It's suggested to fill the description for increase the reach on the marketplace.
                                            </font>

                                            <p style={{ marginTop: 30 }}>Alternative ID</p>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={this.state.alternativeId}
                                                onChange={({ target }) =>
                                                    this.setState({
                                                        alternativeId: target.value,
                                                        disableButton: target.value == ''
                                                    })
                                                }
                                            />
                                            <font style={{ fontSize: '13px', color: '#888' }}>Optional Custom audience ID</font>

                                            <div className="new-segment-based-audience new-segment-based-audience--button-group">
                                                <BorderButton className="grey" label="Cancel" onClick={this.onCancel} />
                                                <BorderButton disabled={this.state.disableButton} label="SAVE" onClick={this.onSave} />
                                                {this.state.saving && <Preloader transparent />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </WhiteBox>
                        </div>
                    </div>
                    {/*
                    <div className="row justify-content-center" style={{ marginTop: 20 }}>
                        <div className="col-10">
                            <WhiteBox>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        marginBottom: 20
                                    }}>
                                    <h3 className="box-title">Your Segments:</h3>
                                    <div style={{ flex: 1 }} />
                                    <Selector
                                        variants={['vertical']}
                                        selected={this.state.stsegments}
                                        onChangeSelection={stsegments => this.setState({ stsegments })}
                                    />
                                </div>
                                
                                
                            </WhiteBox>
                        </div>
                    </div>
                    */}
                </div>
            </PageWrapper>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    goBack: () => dispatch(push('/audiences'))
})

const mapStateToProps = (state, { match }) => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddAudience)
